import { FlaskConical, X } from 'lucide-react';
import { useState } from 'react';
import { useTestMode } from '../hooks/useTestMode';

/**
 * Persistent amber banner shown at the very top of every page when the
 * application is running in test mode.  Can be dismissed for the current
 * session (state lives only in the component — it reappears on reload, which
 * is intentional: testers should always be reminded they're in test mode).
 */
export function TestModeBanner() {
  const { isTestMode, loading } = useTestMode();
  const [dismissed, setDismissed] = useState(false);

  if (loading || !isTestMode || dismissed) return null;

  return (
    <div className="fixed top-0 left-0 right-0 z-[60] bg-amber-400 text-amber-900 flex items-center justify-between px-4 py-2 text-sm font-medium shadow-md">
      <div className="flex items-center gap-2">
        <FlaskConical className="w-4 h-4 flex-shrink-0" />
        <span>
          <strong>Environnement de test</strong> — les données saisies sont
          destinées aux tests et seront supprimées. Ne pas utiliser de vraies
          informations personnelles.
        </span>
      </div>
      <button
        onClick={() => setDismissed(true)}
        className="ml-4 flex-shrink-0 p-1 rounded hover:bg-amber-500 transition-colors"
        aria-label="Fermer la bannière test"
      >
        <X className="w-4 h-4" />
      </button>
    </div>
  );
}

export default TestModeBanner;
